import { Link } from 'react-router-dom';
import { Logo, Arrow } from '../Icons';

export function CTA({ title = 'Ready to send smarter, or travel lighter on cost?', text = 'Join the community moving items the way people already move: together.' }) {
  return (
    <section className="cta-wrap" id="get-started">
      <div className="container">
        <div className="cta reveal">
          <div className="cta__glow" aria-hidden="true" />
          <h2>{title}</h2>
          <p>{text}</p>
          <div className="cta__actions">
            <Link to="/register?role=sender" className="btn btn--light btn--lg">
              Send an item <Arrow width={18} height={18} />
            </Link>
            <Link to="/register?role=traveller" className="btn btn--glass btn--lg">
              Register a journey
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

const columns = [
  {
    title: 'Product',
    links: [
      ['How it works', '/how-it-works'],
      ['Send luggage', '/send'],
      ['Become a traveller', '/become-a-traveller'],
      ['Search travellers', '/search'],
    ],
  },
  {
    title: 'Trust',
    links: [
      ['Safety guidelines', '/safety'],
      ['Prohibited items', '/prohibited-items'],
      ['FAQs', '/faqs'],
      ['Refund policy', '/terms#refunds'],
    ],
  },
  {
    title: 'Company',
    links: [
      ['About us', '/about'],
      ['Contact us', '/contact'],
      ['Log in', '/login'],
      ['Create account', '/register'],
    ],
  },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <Link to="/" className="brand">
            <Logo />
            <span>PinParcel</span>
          </Link>
          <p>Connecting senders with travellers on the same route, with privacy and admin-verified safety built in.</p>
        </div>
        {columns.map((c) => (
          <div className="footer__col" key={c.title}>
            <h4>{c.title}</h4>
            <ul>
              {c.links.map(([label, to]) => (
                <li key={label}><Link to={to}>{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="container footer__bottom">
        <span>© {new Date().getFullYear()} PinParcel. All rights reserved.</span>
        <div>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/contact">Contact</Link>
        </div>
      </div>
    </footer>
  );
}
